import { gsap } from 'gsap';

function draggableCarouselSetup(el) {
  const { children:headerItems } = el.querySelector('.carousel__header');
  const images = [...el.querySelectorAll('.carousel__image')];

  if (headerItems) gsap.set(headerItems, { autoAlpha: 0, y: -10 })
  if (images) gsap.set(images, { autoAlpha: 0, y: 50 })
}

function draggableCarouselEnter(el) {
  const { children:headerItems } = el.querySelector('.carousel__header');
  const images = [...el.querySelectorAll('.carousel__image')];
  
  const tl = gsap.timeline({ defaults: { duration: 1, ease: 'power2.out' } });

  if (headerItems) tl.to(headerItems, { autoAlpha: 1, y: 0, stagger: 0.3 }, 0)
  if (images) tl.to(images, { autoAlpha: 1, y: 0, scale: 1, stagger: 0.05 }, 0)
}

export { draggableCarouselSetup, draggableCarouselEnter };